import {
  Host,
  OnInit,
  Optional,
  SkipSelf,
  Component,
  forwardRef,
} from '@angular/core';

import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import { PanelInputComponent } from '../panel-input';

import { InputComponentTypesEnum } from '../../enums';
import { PasswordControl } from '../../classes/password-control';
import {Helper} from '../../classes/helpers';

@Component({
  selector: 'app-password-input',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PasswordInputComponent),
    multi: true,
  }],
})
export class PasswordInputComponent extends PanelInputComponent implements OnInit {
  public passwordInputType: string;
  public inputComponentTypes: typeof InputComponentTypesEnum;
  public hasMinLength: boolean;
  public hasUppercase: boolean;
  public hasLowercase: boolean;
  public hasSpecialSymbol: boolean;
  public hasNumber: boolean;
	public hasNoLatinChar: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer,
  ) {
    super(controlContainer);

    this.passwordInputType = InputComponentTypesEnum.Password;
    this.inputComponentTypes = InputComponentTypesEnum;

    this.hasMinLength = false;
    this.hasUppercase = false;
    this.hasLowercase = false;
    this.hasSpecialSymbol = false;
    this.hasNumber = false;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  changePasswordInputType(event: MouseEvent): void {
    this.passwordInputType =
      (this.passwordInputType !== InputComponentTypesEnum.Password) ? InputComponentTypesEnum.Password : InputComponentTypesEnum.Text;

    event.stopPropagation();
  }

  onKeyUp(event: Event): void {
    this.changeValue(event);

    let value = (event.target as HTMLInputElement).value;

    if (event instanceof ClipboardEvent) {
      const clipboardData = event.clipboardData;

      value = !clipboardData ? '' : clipboardData.getData('text');
    }

    this.hasMinLength = value.trim().length >= 8;
    this.hasLowercase = /[a-z]+/.test(value);
    this.hasUppercase = /[A-Z]+/.test(value);
    this.hasNumber = /\d/.test(value);
    this.hasSpecialSymbol = /[^A-Za-z0-9 ]+/.test(value);
	  this.hasNoLatinChar = /[\x20-\x7e]+/.test(value);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  asFormsControl(): PasswordControl {
    if (!this.control) {
      this.control = new PasswordControl({
        name: '',
        value: '',
        placeholder: '',
        validators: [],
        componentType: 0,
        invalid: false,
        hintDisabled: false,
        errors: [],
      });
    }

    if ((typeof this.controlPlaceHolder !== 'undefined') && this.control) {
      this.control.placeholder = this.controlPlaceHolder;
    }

    return (this.control as PasswordControl);
  }
}
